exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".retail-products-configuration .spark-checkbox {\n  width: fit-content; }\n\n.retail-products-configuration .accordion-checkbox label {\n  padding: 0; }\n\n.retail-products-configuration .accordion-checkbox h4 {\n  margin-bottom: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/pages/retailProducts/RetailProductsConfiguration.scss
// module id = 1379
// module chunks = 0